import { DownOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, type ButtonProps, Dropdown } from "antd"
import React, { useState } from "react"
import { useNavigate } from "react-router"

import { RoutesPaths } from "../../../constants/routes.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import ProjectsLeadApproval from "./ProjectsLeadApproval.tsx"

interface ProjectsLeadApprovalTriggerProps {
  onRefetchCallback: () => void
}

export function ProjectsLeadApprovalTrigger({
  onRefetchCallback
}: ProjectsLeadApprovalTriggerProps) {
  const canConvertLeadToProject = useAppSelector(
    (state) =>
      state?.auth?.userInfo?.permissions?.codes?.projects?.features
        ?.project_approval
  )

  const navigation = useNavigate()
  const [openModal, setOpenModal] = useState(false)

  const toggleOpenModal = () => setOpenModal(!openModal)

  const onCloseHandler = (refetch = false) => {
    if (refetch) onRefetchCallback()
    setOpenModal(false)
  }

  const buttonProps: ButtonProps = {
    onClick: () => navigation(RoutesPaths.project.add),
    type: "primary",
    className: "w-auto",
    icon: <PlusOutlined />
  }

  return (
    <>
      {canConvertLeadToProject ? (
        <Dropdown.Button
          {...buttonProps}
          icon={<DownOutlined />}
          menu={{
            items: [
              {
                key: "from_lead",
                icon: <PlusOutlined />,
                label: "Create from lead",
                onClick: toggleOpenModal
              }
            ]
          }}
        >
          <PlusOutlined /> New Project
        </Dropdown.Button>
      ) : (
        <Button {...buttonProps} icon={<PlusOutlined />}>
          New Project
        </Button>
      )}

      {/*@todo add lazy + suspense */}
      {openModal && <ProjectsLeadApproval onClose={onCloseHandler} />}
    </>
  )
}
